<!-- TEMPLATE -->
<template>
  <div class="wrapper">
    <dean-dialog
      :title="title"
      :small="true"
    >
      <slot><!--Slot for load overlay-->

      </slot>
      <dean-notification :is-modal="true">

      </dean-notification>
      <p>{{text}}</p>
      <span slot="dean-dialog-button-group">
        <dean-button :danger="true" :dialog-button="true" @click.native="close()">Nee</dean-button>
        <dean-button :success="true" :dialog-button="true" @click.native="doYesClick()">Ja</dean-button>
      </span>
    </dean-dialog>
  </div>
</template>

<!-- SCRIPT -->
<script lang="ts">
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import axios from 'axios';
  import {
    // SVG
    warningIcon,
    trashIcon,
    // COMPONENTS
    deanDialog,
    deanDialogButtonGroup,
  } from '@deanone/dean-components';
  import deanSelectFormRow from '@/components/deanComponents/deanSelectFormRow.vue';
  import deanButton from '@/components/deanComponents/deanButton.vue';
  import DeanNotification from '@/components/deanComponents/deanNotification.vue';
  import deanFormRow from '@/components/deanComponents/deanFormRow.vue';
  import {deanDialogBus} from '@/main';

  @Component({
    components: {
      warningIcon,
      DeanNotification,
      deanDialog,
      deanButton,
      deanFormRow,
      deanSelectFormRow,
      deanDialogButtonGroup,
    },
  })

  export default class DeletePartnerDialog extends Vue {
    // DATA
    @Prop() public payloadData!: {
      [key: string]: any,
    };
    public data: {[key: string]: any} = {};
    public deleting: boolean = true;

    // COMPUTED
    get title() {
      return this.payloadData.name + (this.deleting ? ' verwijderen?' : ' herstellen?');
    }

    get text() {
      let text = 'Weet u het zeker? Hiermee wordt partner ' + this.payloadData.name;
      text += this.deleting ? ' verwijderd.' : ' hersteld.';

      return text;
    }

    // METHODS
    public close() {
      deanDialogBus.$emit('close');
    }

    public doYesClick() {
      if (this.deleting) {
        this.deletePartner();
      } else {
        this.undeletePerson();
      }
    }

    public deletePartner() {
      this.$emit('setLoad', true);

      const url = '/-/trade/api/partner.delete';

      const requestData = {
        id: this.payloadData.params.id,
      };

      axios.post(url, requestData).then(
          (response) => {
            deanDialogBus.$emit('personDelete', this.deleting ? 'verwijderd' : 'hersteld');

            this.close();
          },
          (error) => {
            this.$toast({
              icon: warningIcon,
              text: 'Er kan momenteel niet worden verwijderd, probeer het later opnieuw.',
              theme: 'danger',
            });
          },
        ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public undeletePerson() {
      this.$emit('setLoad', true);

      const url = '/-/trade/api/partner.undelete';

      const requestData = {
        id: this.payloadData.params.id,
      };

      axios.post(url, requestData).then(
          (response) => {
            deanDialogBus.$emit('personDelete');

            this.close();
          },
          (error) => {
            this.$toast({
              icon: warningIcon,
              text: 'Er kan momenteel niet worden hersteld, probeer het later opnieuw.',
              theme: 'warning',
            });
          },
        ).finally(() => {
        this.$emit('setLoad', false);
      });
    }

    public created() {
      if (this.payloadData.deleting !== undefined) {
        this.deleting = this.payloadData.deleting;
      }
    }

    public destroyed() {
      this.$emit('setLoad', false);
    }
  }
</script>

<!-- STYLE -->
<style lang="scss" scoped>
  // IMPORT
  @import '~@deanone/dean-components/src/scss/vars';
</style>
